<template>
  <div>
    <div v-if="$store.state.user_doc.ssoRoundTripId != ssoRoundTripId">
      <h2>Connecting to forum</h2>
      <b-button variant="primary" disabled>
        <b-spinner small />
        Authorizing...
      </b-button>
      <p>
        <small>ID: {{ ssoRoundTripId }}</small>
      </p>
    </div>
    <div v-else>
      <h2>Forum login successful</h2>
      <b-btn :href="ssoReturnUrl" variant="primary">Proceed to Forum</b-btn>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "DiscourseSSOLink",
  components: {},
  data() {
    return {
      ssoRoundTripId: null
    };
  },
  computed: {
    ssoReturnUrl() {
      if ("discourse_query" in this.$store.state.user_doc) {
        return (
          "https://forum.soundslides.org/session/sso_login?" +
          this.$store.state.user_doc.discourse_query
        );
      }
      return null;
    }
  },
  mounted() {
    this.ssoRoundTripId = Math.random()
      .toString(36)
      .substring(7); // Id to save and confirm that sso object is fresh.
    var sso_object = {
      sso: this.$route.query.sso,
      sig: this.$route.query.sig,
      ssoRoundTripId: this.ssoRoundTripId
    };
    this.$store.dispatch("create_sso", sso_object);
  }
};
</script>
